
import React, { useState, useEffect } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import { ReactComponent as ArrowIcon } from '../Asset/up-arrow-svgrepo-com.svg';
import arrowBottom from '../Asset/Arrow 6.png';

 
const GroupTermLifeFAQ= () => {

  const [faqs] = useState([
    {
        question: "Q1. How does group term life insurance differ from individual life insurance?",
        answer:
      (
        <>
           Group term life insurance is offered by 
           <span style={{ color: "#F37435", fontWeight: "700" }} > employers to their employees </span>at a lower cost, with the same coverage terms for everyone, and usually doesn't require a medical exam for basic coverage. It's affordable because the cost is shared among the group, and employers often help pay the premiums.
           Individual life insurance, on the other hand, is <span style={{ color: "#F37435", fontWeight: "700" }} >bought directly by a person </span>and customized to their specific needs and health profile, making it more expensive. This type of insurance typically requires a medical exam unlike group term life insurance.
        </>
      )
      },
      {
        question: "Q2. What is the cost of group term life insurance?",
        answer:
      (
        <>
           Group term life insurance is offered by 
           <span style={{ color: "#F37435", fontWeight: "700" }} > employers to their employees </span>at a lower cost, with the same coverage terms for everyone, and usually doesn't require a medical exam for basic coverage. It's affordable because the cost is shared among the group, and employers often help pay the premiums.
           Individual life insurance, on the other hand, is <span style={{ color: "#F37435", fontWeight: "700" }} >bought directly by a person </span>and customized to their specific needs and health profile, making it more expensive. This type of insurance typically requires a medical exam unlike group term life insurance.
        </>
      )
      },
      {
        question: "Q3. How does group term life insurance differ from individual life insurance?",
        answer:
      (
        <>
          The cost of group term life insurance is generally lower than individual policies because the risk is spread across many people. <span style={{ color: "#F37435", fontWeight: "700" }} >
          Employers often cover some or all of the basic premium costs,</span> making it very affordable or even free for employees.
          If employees choose to buy additional coverage, they typically pay a discounted rate negotiated by the employer.
        </>
      )
      },
      {
        question: "Q4. How much coverage does group term life insurance provide?",
        answer:
      (
        <>
           Group term life insurance coverage amounts can vary, but they are typically tied to the employee's salary. Commonly, the coverage is a <span style={{ color: "#F37435", fontWeight: "700" }} >
           multiple of the employee's annual salary,</span> such as one to three times their salary.
          Some employers offer a fixed coverage amount instead.
        In addition to the basic coverage, employees often have the option to purchase additional coverage at an extra cost, which can increase the total benefit amount. However, there are usually limits on the maximum coverage available through the group policy.
        </>
      )
      },
      {
        question: "Q5. Can I change my beneficiaries after initially setting them?",
        answer:
      (
        <>
           <span style={{ color: "#F37435", fontWeight: "700" }} >Yes,</span> you can generally change your beneficiaries for your group term life insurance policy. Most insurance plans allow policyholders to update their beneficiary at any time.
        </>
      )
      },
      {
        question: "Q6. Does group term life insurance coverage reduce or end at a certain age?",
        answer:
      (
        <>
          Yes, in many cases, group term life insurance coverage may<span style={{ color: "#F37435", fontWeight: "700" }} >
          reduce or end at a certain age, </span>often around retirement age.
         <br></br>Some policies have age-related reductions where the coverage amount decreases gradually as the insured individual reaches a specific age milestone, such as 65 or 70 years old.
         <br></br>In other instances, coverage may terminate altogether at a specified age, typically when the insured reaches retirement age or leaves the workforce.
        </>
      )
      },
      {
        question: "Q7. How do I know if I need additional life insurance beyond my group term policy?",
        answer:
      (
        <>
           Consider whether your group term coverage is enough to support your family's financial needs, like mortgage payments and education expenses. Think about your health and future costs, as individual policies might cost more as you get older. <span style={{ color: "#F37435", fontWeight: "700" }} >
           Talking to our advisor can help you </span>decide if extra coverage is right for you and your loved ones.
        </>
      )
      },
      {
        question: "Q8. What happens to the coverage if an employee leaves the company?",
        answer:
      (
        <>
           Typically, group term life insurance coverage ends when an employee leaves the company. This means the employee no longer has insurance through the group policy provided by their employer. However, <span style={{ color: "#F37435", fontWeight: "700" }} >
           some policies may offer options for continuation or conversion. Continuation allows the employee to maintain coverage for a limited period after leaving the company, usually at their own expense and without employer contributions.</span> Conversion, on the other hand, allows the employee to convert their group term policy into an individual life insurance policy without the need for a medical exam, although premiums may be higher.
        </>
      )
      },
      {
        question: "Q9. How do beneficiaries claim the death benefit?",
        answer:
      (
        <>
           Beneficiaries typically need to file a claim with the insurance company after the policyholder passes away. They'll need to provide the death certificate and any required forms. Once submitted, the insurance company processes the claim and disburses the death benefit to the designated beneficiaries. It's important to keep beneficiary information updated to ensure a smooth claims process during a difficult time.
        </>
      )
      },
      {
        question: "Q10. How does group term life insurance affect taxes? Are premiums paid by the employer taxable income?",
        answer:
      (
        <>
           Premiums paid by an employer for group term life insurance are <span style={{ color: "#F37435", fontWeight: "700" }} >
           generally not considered taxable income </span>for employees, regardless of the coverage amount. This includes both basic coverage and any additional coverage provided by the employer.
           However, if the employee voluntarily contributes to the premiums or if the coverage exceeds certain limits, such as 10% of the sum assured (the amount promised to be paid if something happens to the insured), the excess may be taxable as employee benefits. This means that any extra insurance coverage provided by the employer above this limit could be seen as a special benefit, similar to getting something extra nice from your employer, and it might be taxable income that you need to pay taxes on.
        </>
      )
      },
  ]);

  const [visible, setVisible] = useState(false);
const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
const [isMobile, setIsMobile] = useState(false);

const toggleVisibility = () => {
  if (window.pageYOffset > 100) {
    setVisible(true);
  } else {
    setVisible(false);
  }
};

const scrollToTop = () => {
  setVisible(false); // Hide the button immediately when clicked
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

useEffect(() => {
  window.addEventListener('scroll', toggleVisibility);
  return () => {
    window.removeEventListener('scroll', toggleVisibility);
  };
}, []);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener('resize', handleResize);
  handleResize();

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);

const handleFaqClick = (index) => {
  setSelectedFaqIndex(selectedFaqIndex === index ? index : index);
};
return(
  <div>
     <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <ArrowIcon className="arrow-icon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            style={styles.scroll}
          >
            <img src={arrowBottom} alt="Scroll to top" style={{ height: '2rem' }} />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '10px',
    bottom: '10px',
    cursor: 'pointer',
    width: '50px',
    height: '50px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
  },
  span: {
    display: 'block'
  }
};
export default GroupTermLifeFAQ;